import { render, staticRenderFns } from "./board-view-widget.vue?vue&type=template&id=52d2f2e6&"
import script from "./board-view-widget.vue?vue&type=script&lang=js&"
export * from "./board-view-widget.vue?vue&type=script&lang=js&"
import style0 from "./board-view-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports